<template>
  <div class="header-index-warp">
    <van-nav-bar title="标题">
      <template #left>
        <img src="@/assets/image/back.png" alt @click="onClickLeft" />
      </template>
      <template #title>
        <div class="center">
          {{title}}
        </div>
      </template>
      <template #right  v-if="showRigIcon" >
        <div class="btn" v-if="showRightIcon" @click="onClickRight">添加商品</div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
import utils from "@/utils/common";
import { Form } from 'vant';
export default {
    props:{
      title:{
        type: String,
        default: '已参与商品'
      },
      showRigIcon:{
        type: Boolean,
        default: true
      }
    },
    data() {
        return {
            showRightIcon: true
        }
    },
    methods: {
        onClickLeft() {
            utils.goBack();
          utils.nativeMethod({tm: 1000004,tp:{pageCode:3}})
        },
        onClickRight() {
          this.$emit('clickRight')
        },
        onJumpToSearch() {}
    }
}
</script>
<style lang="less" scoped>
.header-index-warp {
  position: relative;
  display: block;
  .van-nav-bar__left {
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
      display: block;
    }
  }
  .van-nav-bar__title {
    font-size: 32px;
    color: #333;
    font-weight: 500;
    .center {
      width: 205px;
      text-align: center;
    }
  }
  .van-nav-bar__right {
    .btn {
      background-color: var(--epButtonColor);
      font-size: 24px;
      color: var(--epTextColor);
      text-align: center;
      width: 160px;
      height: 60px;
      line-height: 60px;
      border-radius: 10px;
    }
  }
}
</style>